import { createFileRoute } from '@tanstack/react-router';
import { loadShire, makeShireSubPageHead, type ShireLoaderData } from '../components/shared/shire-sub-route';
import { ShireSubPageShell } from '../components/shared/ShireSubPageShell';
import { DfesWarningsPanel } from '../components/shared/DfesWarningsPanel';
import { FloodGuidance } from '../components/shared/FloodGuidance';
import { EmergencyContactsSection } from '../components/shared/ShireInlineSections';

export const Route = createFileRoute('/shire/$name_/emergency')({
  loader: ({ params }) => loadShire(params.name),
  head: (ctx) =>
    makeShireSubPageHead(
      (ctx as { loaderData?: ShireLoaderData } | undefined)?.loaderData,
      'Emergency',
      'Emergency contacts, flood guidance, power outage lines and live DFES warnings for this shire.',
    ),
  component: EmergencyPage,
});

function EmergencyPage() {
  const { shire } = Route.useLoaderData() as ShireLoaderData;
  return (
    <ShireSubPageShell
      shire={shire}
      eyebrow="Emergency"
      title="Emergency & safety"
      lede={`Who to call in an emergency, live DFES warnings, flood guidance and power outage contacts for the Shire of ${shire.name}.`}
    >

      <EmergencyContactsSection shire={shire} />
      <DfesWarningsPanel shireId={shire.id} />
      <FloodGuidance shireId={shire.id} />
    </ShireSubPageShell>
  );
}
